import LegalShell, { Fill, LegalSection } from "@/components/LegalShell";
import { COMPANY as C } from "@/pages/legal/companyInfo";
import Seo from "@/components/Seo";

export default function LegalNotice() {
  return (
    <LegalShell eyebrow="Informations légales" title="Mentions légales" updated={C.updated}>
      <Seo title="Mentions légales — BIZARRE AI" description="Mentions légales de BIZARRE AI : éditeur, directeur de publication, hébergement." path="/mentions-legales" />
      <LegalSection n="1" title="Éditeur de l'application">
        <p>L'application <span className="text-white">{C.appName}</span> est éditée par :</p>
        <ul className="mt-2 space-y-1">
          <li>Raison sociale : <Fill>{C.raisonSociale}</Fill></li>
          <li>Forme juridique : <Fill>{C.formeJuridique}</Fill></li>
          <li>Capital social : <Fill>{C.capital}</Fill></li>
          <li>SIRET / SIREN : <Fill>{C.siret}</Fill></li>
          <li>RCS : <Fill>{C.rcs}</Fill></li>
          <li>N° TVA : <Fill>{C.tva}</Fill></li>
          <li>Adresse : <Fill>{C.adresse}</Fill></li>
          <li>E-mail : <Fill>{C.email}</Fill></li>
          <li>Téléphone : <Fill>{C.telephone}</Fill></li>
        </ul>
      </LegalSection>
      <LegalSection n="2" title="Directeur de la publication">
        <p><Fill>{C.directeurPublication}</Fill></p>
      </LegalSection>
      <LegalSection n="3" title="Hébergement">
        <p>L'application est hébergée par :</p>
        <ul className="mt-2 space-y-1">
          <li>Hébergeur : <Fill>{C.hebergeur}</Fill></li>
          <li>Adresse : <Fill>{C.hebergeurAdresse}</Fill></li>
        </ul>
      </LegalSection>
      <LegalSection n="4" title="Propriété intellectuelle">
        <p>L'ensemble des contenus (textes, illustrations, logo, charte graphique, code) présents dans
        {" "}{C.appName} est protégé par le droit de la propriété intellectuelle. Toute reproduction ou
        réutilisation sans autorisation écrite préalable est interdite.</p>
      </LegalSection>
      <LegalSection n="5" title="Responsabilité">
        <p>{C.appName} fournit des informations générales à visée pédagogique. Elles ne constituent pas
        un conseil juridique, médical ou psychologique personnalisé. Pour toute situation particulière,
        rapprochez-vous d'un professionnel qualifié.</p>
      </LegalSection>
      <LegalSection n="6" title="Contact">
        <p>Pour toute question : <Fill>{C.email}</Fill></p>
      </LegalSection>
    </LegalShell>
  );
}
